import ReactDOM from 'react-dom/client';
import './index.css';
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

//React组件可以直接通过JSX渲染
root.render(<App />);